// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
import VueMask from 'v-mask'

// import translateAPI from '@/assets/libs/translate.js'
// Vue.prototype.$translate = translateAPI.translate
// Vue.prototype.$translateComponent = translateAPI.translateComponent

Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(VModal, { dynamic: true, dialog: true })
Vue.use(VueMask)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js